import React from "react";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

const JobInstructions = ({
  classes,
  jobName,
  isReadOnly,
  setJobName,
  customers,
  customerId,
  setCustomerId,
  description,
  setDescription,
  quantity,
  setQuantity,
  price,
  setPrice,
  orderReceivedDate,
  setOrderReceivedDate,
  deliveryDate,
  setDeliveryDate,
  purchaseOrderNo,
  setPurchaseOrderNo,
  quoteNo,
  setQuoteNo,
  suppliers,
  supplierId,
  setSupplierId,
  canViewSuppliers,
  isNewJob,
  canViewCustomers = true,
}) => {
  return (
    <Paper className={classes.paper} sx={{ height: "100%" }}>
      <h3 className={classes.detailsHeader}>
        <b>Job Name & Instructions</b>
      </h3>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputLabel className="inputFormCustomLabel">Job Name</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Enter Job Name"
            value={jobName}
            onChange={(e) => setJobName(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        {canViewCustomers && (
          <Grid item xs={12}>
            <InputLabel className="inputFormCustomLabel">Select customer</InputLabel>
            {isReadOnly ? (
              (() => {
                const customer = customers.find((c) => c.User_id === customerId);
                const customerName = customer ? `${customer.FirstName} ${customer.LastName}` : "";
                return (
                  <TextField fullWidth variant="outlined" size="small" value={customerName} InputProps={{ readOnly: true }} />
                );
              })()
            ) : (
              <TextField
                select
                fullWidth
                variant="outlined"
                size="small"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
              >
                {customers.map((customer) => (<MenuItem key={customer.User_id} value={customer.User_id}>{customer.FirstName} {customer.LastName}</MenuItem>))}
              </TextField>
            )}
          </Grid>
        )}
        {canViewSuppliers && (
          <Grid item xs={12}>
            <InputLabel className="inputFormCustomLabel">Select Supplier</InputLabel>
            {isNewJob ? (
              <TextField
                select
                fullWidth
                variant="outlined"
                size="small"
                value={supplierId}
                onChange={(e) => setSupplierId(e.target.value)}
              >
                {suppliers.map((supplier) => (
                  <MenuItem key={supplier.User_id} value={supplier.User_id}>
                    {supplier.FirstName} {supplier.LastName}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              (() => {
                const supplier = suppliers.find((s) => s.User_id === supplierId);
                const supplierName = supplier ? `${supplier.FirstName} ${supplier.LastName}` : "";
                return (
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={supplierName}
                    InputProps={{ readOnly: true }}
                  />
                );
              })()
            )}
          </Grid>
        )}
        <Grid item xs={12}>
          <InputLabel className="inputFormCustomLabel">Description</InputLabel>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Enter Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Quantity</InputLabel>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Price</InputLabel>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Order Received</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={orderReceivedDate}
              onChange={(date) => setOrderReceivedDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Delivery Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={deliveryDate}
              onChange={(date) => setDeliveryDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Purchase Order No.</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={purchaseOrderNo}
            onChange={(e) => setPurchaseOrderNo(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">LogoPromo Quote No.</InputLabel>
          <TextField fullWidth variant="outlined" size="small" value={quoteNo} onChange={(e) => setQuoteNo(e.target.value)} InputProps={{ readOnly: isReadOnly }} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(JobInstructions);